module.exports = __webpack_public_path__ + "static/media/model-sorento-um15.38c8b94f.webp";